import Footer from "../footer";
import NavBar from "../navbar";
import { Link } from "react-router-dom";
export default function Terms() {
    return (

        <>

            {/* {Navbar} */}
            <NavBar selected={"terms"}></NavBar>

            <section className="bg-white dark:bg-zinc-800">
                <div className="max-w-screen-xl pt-20 px-4 py-8 mx-auto lg:py-24 lg:px-6 lg:pt-28 ">
                    <div className="max-w-screen-md mx-auto">


                        <h1 className="max-w-2xl mb-4 text-4xl font-extrabold leading-none tracking-tight md:text-5xl xl:text-6xl dark:text-white">
                            Privacy Policy
                        </h1>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            MusicPorter is committed to respecting your privacy regarding any information we may gather from you across our website. This privacy policy governs the use of our website and services. It outlines the obligations and requirements of users, the website, and the website owners. The policy details how we process, store, and protect user data and information.
                        </p>

                        <h2 className="mt-3 mb-4 text-3xl font-extrabold tracking-tight text-gray-900 md:text-3xl dark:text-white">
                            Accessing and Deleting Your Personal Information
                        </h2>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            We do not collect personal information unless it is necessary to provide a service to you. We obtain information by lawful and fair means, with your awareness and consent. We also inform you about why we’re collecting it and how it will be used.
                        </p>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            You have the right to request access to or deletion of your personal information. We may retain certain data as required by law or for legitimate business purposes. If you request deletion, it may affect your ability to use our services.
                        </p>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            To enhance your experience on our site, we might use ‘cookies.’ Cookies are a standard practice, and most major websites use them. A cookie is a small text file that our site may place on your computer to remember your preferences. You can refuse the use of cookies by selecting the appropriate settings on your browser. However, please note that if you do this, you may not be able to use the full functionality of our website.
                        </p>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            To exercise your privacy rights, contact us via email at <Link style={{ color: 'orange' }} to="mailto:hello@musicporter.com">hello@musicporter.com</Link>. Verification of your identity may be required to process your request.
                        </p>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            Alternatively, you can use our <Link style={{ color: 'orange' }} to="/contact-us">contact page</Link> too
                        </p>

                        <h2 className="mt-3 mb-4 text-3xl font-extrabold tracking-tight text-gray-900 md:text-3xl dark:text-white">
                            Third-Party Services
                        </h2>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            We use third-party services to operate Music Porter as required.
                        </p>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            MusicPorter use and transfer of information received from <Link style={{ color: 'orange' }} to="https://developers.google.com/terms/api-services-user-data-policy">Google APIs will comply with the Google API Services User Data Policy</Link>, including the Limited Use requirements.

                        </p>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            By using our services, you agree to the terms of service and privacy policies of third-party platforms we integrate with. We do not share your data with external services unless required to provide our services.

                        </p>



                        <h3 className="mb-4 text-2xl text-gray-900 md:text-3xl dark:text-white">YouTube:</h3>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            MusicPorter utilizes <Link style={{ color: 'orange' }} to="https://developers.google.com/youtube/terms/api-services-terms-of-service">YouTube API Services</Link> on authoriztion from the user and by signing up users accept <Link style={{ color: 'orange' }} to="https://www.youtube.com/t/terms">YouTube’s terms</Link> . Please also review <Link style={{ color: 'orange' }} to="https://policies.google.com/privacy">Google’s Privacy Policy</Link>.</p>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            MusicPorter uses YouTube user data to display on MusicPorter webapp while user selects the songs/playlists/albums they want to transfer. This includes retrieving the user’s YouTube username/channel name, private playlists and liked videos. User data is used solely to provide MusicPorter services and is not shared with any external service.

                        </p>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            We will be storing users playlist names transferred using MusicPorter to let users have access to their transfer history.

                        </p>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            You can revoke MusicPorter’s access to your YouTube data via the <Link style={{ color: 'orange' }} to="https://myaccount.google.com/security">Google security settings page</Link>. For any questions or requests to delete the stored information, you can <Link style={{ color: 'orange' }} to="/contact-us">contact MusicPorter</Link>.

                        </p>




                        <h3 className="mb-4 text-2xl text-gray-900 md:text-3xl dark:text-white">Spotify:</h3>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            MusicPorter uses <Link style={{ color: 'orange' }} to="https://developer.spotify.com/terms">Spotify API Services</Link>. Please also review <Link style={{ color: 'orange' }} to="https://musicporter.com/privacy-and-terms/#:~:text=Spotify%E2%80%99s%20Privacy%20Policy">Spotify’s Privacy Policy</Link>. MusicPorter uses Spotify user information to access, provide, and display Spotify data on MusicPorter. This includes retrieving the user’s Spotify username, private playlists, liked tracks, liked albums, and liked artists. User data is used solely to provide MusicPorter services and is not shared with any external service. You can revoke MusicPorter’s access to your data via the Spotify Apps with access to your Spotify information page. For any questions or complaints, you can contact MusicPorter.</p>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            Spotify® and the <Link style={{ color: 'orange' }} to="https://spotify.com/">Spotify</Link>, logo are trademarks or registered trademarks of Spotify, used under license agreement.

                        </p>




                        <h3 className="mb-4 text-2xl text-gray-900 md:text-3xl dark:text-white">Apple Music:</h3>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            We comply within <Link style={{ color: 'orange' }} to="https://developer.apple.com/support/terms/">Apple Developers Agreement</Link> to handle the user data fetched from your account. Please also review, <Link style={{ color: 'orange' }} to="https://www.apple.com/legal/internet-services/itunes/">Apple Media Services Terms</Link> – Conditions. We do not share any information collected from Apple Music to any other services.

                        </p>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            Apple Music® and the <Link style={{ color: 'orange' }} to="https://music.apple.com/subscribe?app=music&at=11lt62&ct=applemusicapp&ls=1">Apple Music</Link>, logo are trademarks or registered trademarks of Apple Music, used under license agreement.

                        </p>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            We retain collected information only as long as necessary to provide you with your requested service. We protect the data we store within commercially acceptable means to prevent loss and theft, as well as unauthorized access, disclosure, copying, use, or modification.

                        </p>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            We do not share any personally identifying information publicly or with third parties, except when required to by law.

                        </p>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.

                        </p>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            Your continued use of our website will be regarded as acceptance of our practices around privacy and personal information. If you have any questions about how we handle user data and personal information, feel free to contact

                        </p>




                        <h1 className="max-w-2xl mb-4 text-4xl font-extrabold leading-none tracking-tight md:text-5xl xl:text-6xl dark:text-white">
                            Terms and conditions
                        </h1>

                        <h3 className="mb-4 text-2xl text-gray-900 md:text-3xl dark:text-white">1. Acceptance of Terms
                            :</h3>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            By accessing and using the <Link style={{ color: 'orange' }} to="https://musicporter.com/">MusicPorter website</Link>, you agree to comply with and be bound by these terms and the respective laws and regulations. If you do not agree, you should not use the service.

                        </p>


                        <h3 className="mb-4 text-2xl text-gray-900 md:text-3xl dark:text-white">2. Service Description</h3>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            MusicPorter allows users to transfer music playlists and libraries between various music streaming services. Our service may be updated, changed, or discontinued at any time without notice.

                        </p>


                        <h3 className="mb-4 text-2xl text-gray-900 md:text-3xl dark:text-white">3. User Obligations</h3>

                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            You must provide accurate and current information when creating an account. You are responsible for maintaining the confidentiality of your account and password and for any activities that occur under your account. Any misuse or unintended usage of the access to our service will authorize use to refuse and terminate access to your account.

                        </p>


                        <h3 className="mb-4 text-2xl text-gray-900 md:text-3xl dark:text-white">4. Privacy</h3>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            Our Privacy Policy explains how we collect, use, and protect your information. By using the service, you consent to the collection and use of this information as outlined in our Privacy Policy.

                        </p>


                        <h3 className="mb-4 text-2xl text-gray-900 md:text-3xl dark:text-white">5. Intellectual Property
                            :</h3>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            All content, including text, graphics, logos, and software, is the property of MusicPorter or its content suppliers and is protected by international copyright laws. Unauthorized use of any content is prohibited.

                        </p>


                        <h3 className="mb-4 text-2xl text-gray-900 md:text-3xl dark:text-white">6. Prohibited Activities</h3>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            Users are prohibited from using the service for any unlawful purpose, transmitting any harmful code, or interfering with the service’s operation. Any violations may result in termination of your account.

                        </p>


                        <h3 className="mb-4 text-2xl text-gray-900 md:text-3xl dark:text-white">7. Third-Party Services</h3>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            MusicPorter uses APIs from third-party services like YouTube, Spotify and Apple Music. By using our service, you agree to comply with the terms of these third-party services. We are not responsible for the content or practices of these third-party services and not associated with them.

                        </p>


                        <h3 className="mb-4 text-2xl text-gray-900 md:text-3xl dark:text-white">8. Indemnification</h3>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            You agree to indemnify and hold MusicPorter harmless from any claims, damages, or expenses arising from your use of the service or your violation of these terms.

                        </p>

                        <h3 className="mb-4 text-2xl text-gray-900 md:text-3xl dark:text-white">9. Termination</h3>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            We reserve the right to terminate or suspend your account and access to the service at our sole discretion, without notice, for conduct that we believe violates these terms or is harmful to other users of the service.

                        </p>

                        <h3 className="mb-4 text-2xl text-gray-900 md:text-3xl dark:text-white">10. Limitation of Liability</h3>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            MusicPorter is not liable for any direct, indirect, incidental, or consequential damages arising from your use of the service. The service is provided “as is” without warranties of any kind.

                        </p>

                        <h3 className="mb-4 text-2xl text-gray-900 md:text-3xl dark:text-white">11. Changes to Terms</h3>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            MusicPorter reserves the right to modify these terms at any time. Your continued use of the service following any changes will constitute your acceptance of the new terms.

                        </p>

                        <h3 className="mb-4 text-2xl text-gray-900 md:text-3xl dark:text-white">12. Governing Law</h3>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            These terms are governed by and construed in accordance with the laws of the jurisdiction in which MusicPorter operates, without regard to its conflict of law principles.

                        </p>

                        <h1 className="max-w-2xl mb-4 text-4xl font-extrabold leading-none tracking-tight md:text-5xl xl:text-6xl dark:text-white">
                            Contact us
                        </h1>


                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                            If you have any questions about the terms and privacy, please contact us at <Link style={{ color: 'orange' }} to="mailto:hello@musicporter.com">hello@musicporter.com</Link>. Alternatively, you can use our <Link style={{ color: 'orange' }} to="/contact-us">contact page</Link> too


                        </p>

                    </div>
                </div>
            </section>


            <Footer></Footer>
        </>
    )
}